export enum BulkPriceEntityTypes {
  INVENTORY = 'INVENTORY',
  LAB_TEST = 'LAB_TEST',
  PROCEDURE = 'PROCEDURE',
}
